import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import LogoSvg from './yougile-logo.svg'

const TwLogo = tw.a`
  flex-none
  h-full
  flex
  items-center
  gap-8
`

const TwText = tw.span`
  text-sm-regular
  text-panel-text-placeholder
`

const TwImage = tw(LogoSvg)`
  text-panel-text-placeholder
`

export const Logo = ({className}: {className?: string}) => (
  <TwLogo href="https://yougile.com" target="_blank" className={className}>
    <TwText>{Lang.msg.share.poweredBy}</TwText>
    <TwImage height={16} width={69} viewBox="0 0 500 116" />
  </TwLogo>
)
